import { Injectable } from '@angular/core';

import { AppRoute } from '@data/constants';
import { Role } from '@data/enums';
import { MenuItem } from '@data/models';
import { AuthService } from '@data/services';

const data: MenuItem[] = [
  // {
  //     path: AppRoute.DATOS_PERSONALES,
  //     icon: 'record_voice_over',
  //     label: 'Actualización de datos',
  // },
  {
    icon: 'payment_icon',
    svg: true,
    label: 'Cronograma de Pagos',
    type: 2,
  },
  // {
  //   path: AppRoute.CAMBIAR_CONTRA,
  //   icon: 'https',
  //   label: 'Cambiar Contraseña',
  // },
  {
    path: AppRoute.MIS_MARCACIONES,
    icon: 'marcacion_icon',
    svg: true,
    label: 'Mis Marcaciones',
  },
  // {
  //   path: AppRoute.ADMINISTRAR_USUARIOS,
  //   icon: 'settings',
  //   label: 'Administrar Usuarios',
  //   roles: [Role.ADMIN_CENTRAL, Role.ADMIN_SEDE],
  // },
  {
    icon: 'settings',
    label:'Administracion',
    type: 3,
    roles: [Role.ADMIN_CENTRAL,Role.ADMIN_SEDE],
    children:[
      {
        path: `${AppRoute.ADMINISTRACION}/${AppRoute.ADMINISTRAR_USUARIOS}`,
        icon: 'insert_chart',
        label: 'Usuarios por Red',
        roles: [Role.ADMIN_CENTRAL,Role.ADMIN_SEDE],
      },
      // {
      //   path: `${AppRoute.ADMINISTRACION}/${AppRoute.ADMINISTRAR_RENUEVA}`,
      //   icon: 'library_books',
      //   label: 'Proyectos de Renueva EsSalud',
      //   roles: [Role.ADMIN_CENTRAL],
      // },
      {
        path: `${AppRoute.ADMINISTRACION}/${AppRoute.ADMINISTRAR_MANTENIMIENTO_USUARIOS}`,
        icon: 'people',
        label: 'Mantenimiento de Usuarios',
        roles: [Role.ADMIN_CENTRAL],
      },
      // {
      //   path: `${AppRoute.ADMINISTRACION}/${AppRoute.ADMINISTRAR_INSCRIPCIONES}`,
      //   icon: 'settings',
      //   label: 'Campañas Asignadas',
      // },
    ]
  },
  {
    path: `${AppRoute.ADMINISTRACION}/${AppRoute.ADMINISTRAR_INSCRIPCIONES}`,
    icon: 'library_books',
    label: 'Campañas Asignadas',
    type: 4
  },
  // {
  //     path: AppRoute.MARCACION_TRABAJADOR,
  //     icon: 'airplanemode_active',
  //     label: 'Mis vacaciones',
  // },
  {
      path: AppRoute.MIS_BOLETAS,
      icon: 'payment',
      label: 'Mis Boletas de Pago',
      type: 2,
  },
  // {
  //   path: '',
  //   icon: 'contact_mail',
  //   label: 'Legajo Personal',
  // },
  // // {
  // //   path: AppRoute.CONTROL_ACCESO,
  // //   icon: 'check_circle',
  // //   label: 'Control de Acceso'
  // // },
  // // {
  // //   path: AppRoute.MARCACION_TRABAJADOR,
  // //   icon: 'how_to_reg',
  // //   label: 'Marcación para Trabajador',
  // //   roles: [Role.ADMIN_CENTRAL, Role.ADMIN_SEDE],
  // // },
  // {
  //   path: AppRoute.MIS_MARCACIONES,
  //   icon: 'assignment',
  //   label: 'Mis Marcaciones',
  //   roles: [Role.ADMIN_CENTRAL, Role.ADMIN_SEDE],
  // },
  // // {
  // //   path: AppRoute.PANEL_MARCACION,
  // //   icon: 'assignment_turned_in',
  // //   label: 'Panel de Marcación',
  // //   roles: [Role.ADMIN_CENTRAL, Role.ADMIN_SEDE, Role.CONTROL_ACCESO],
  // // },
  // {
  //   path: AppRoute.MANTENIMIENTOS,
  //   icon: 'widgets',
  //   label: 'Mantenimientos',
  //   roles: [Role.ADMIN_CENTRAL, Role.ADMIN_SEDE],
  // },
  // {
  //   path: AppRoute.SETTINGS,
  //   icon: 'settings',
  //   label: 'Configuraciones',
  //   roles: [Role.ADMIN_CENTRAL, Role.ADMIN_SEDE],
  // },
  // // {
  // //   path : AppRoute.DDJJ_CONFLICTO,
  // //   icon : 'ddjj',
  // //   svg : true,
  // //   label : 'DD.JJ'
  // // }
];

@Injectable({ providedIn: 'root' })
export class MenuService {
  constructor(private _authService: AuthService) { }
  getAll() {
    const idRolSession = this._authService.getUserSession().idRol;
    return data.filter(
      (opt) => !opt.roles?.length || opt.roles.includes(idRolSession)
    );
  }
}
